import { getLimitDays, getVacationMinLength, getVacationLengthErrorText, updateLeftDaysText } from '../DocumentHelpers.js';
import { vacationKinds, formModes, documentStatuses } from '../../../constants.js';
import moment from 'moment';

export default {
    updateFields(documentData, context) {
        const { formMode, limitsInfo, hasSignBtn, setCanAddFiles } = context;
        const nowDate = new Date();

        const kindVal = documentData.properties['sx:dfDocKind'];
        const leftDays = getLimitDays(documentData, limitsInfo);
        const startDateField = documentData.form.fields.find(f => f.name === 'sx:claimDateStart');
        const endDateField = documentData.form.fields.find(f => f.name === 'sx:claimDateEnd');

        if (formMode !== formModes.read) {
            if (kindVal === vacationKinds.unpaid || kindVal === vacationKinds.martiallaw) {
                startDateField.minValue = nowDate.getHours() >= 12 ? moment(nowDate).add(1, "days").format("YYYY-MM-DD") : moment(nowDate).format("YYYY-MM-DD");
            }
            else {
                startDateField.minValue = moment(nowDate).add(5, "days").format("YYYY-MM-DD");
            }

            if (leftDays === 0 && !limitsInfo?.benefits) {
                startDateField.disabled = true;
                endDateField.disabled = true;
                documentData.properties['sx:claimDateStart'] = '';
                documentData.properties['sx:claimDateEnd'] = '';
                documentData.properties['sx:claimeDaysSum'] = '';
            }
            else {
                startDateField.disabled = false;

                const startDateFieldValue = documentData.properties['sx:claimDateStart'];
                const startDate = new Date(startDateFieldValue);
                const minDate = new Date(startDateField.minValue);
                if (startDate < minDate) {
                    documentData.properties['sx:claimDateStart'] = '';
                }


                if (documentData.properties['sx:claimDateStart']) {
                    endDateField.disabled = false;

                    const minVacationLength = getVacationMinLength(kindVal);
                    endDateField.minValue = moment(startDate).add(minVacationLength > 0 ? minVacationLength - 1 : 0, 'days').format('YYYY-MM-DD');


                    if (leftDays > 0 && !limitsInfo?.benefits) {
                        endDateField.maxValue = moment(startDate).add(leftDays - 1, 'days').format('YYYY-MM-DD');
                    }
                    else {
                        endDateField.maxValue = '';
                    }

                    if (documentData.properties['sx:claimDateEnd']) {
                        if (new Date(documentData.properties['sx:claimDateEnd']) < new Date(endDateField.minValue)) {
                            documentData.properties['sx:claimDateEnd'] = '';
                        }
                        if (endDateField.maxValue && new Date(documentData.properties['sx:claimDateEnd']) > new Date(endDateField.maxValue)) {
                            documentData.properties['sx:claimDateEnd'] = '';
                        }
                    }
                }
                else {
                    endDateField.disabled = true;
                    documentData.properties['sx:claimDateEnd'] = '';
                }

                let sum = '';
                if (documentData.properties['sx:claimDateStart'] && documentData.properties['sx:claimDateEnd']) {
                    const endDate = new Date(documentData.properties['sx:claimDateEnd']);
                    sum = ((endDate - startDate) / (1000 * 60 * 60 * 24) + 1).toFixed();
                }
                documentData.properties['sx:claimeDaysSum'] = sum;
            }
        }

        const sumField = documentData.form.fields.find(f => f.name === 'sx:claimeDaysSum');
        sumField.visible = kindVal !== vacationKinds.martiallaw;
        sumField.errorText = getVacationLengthErrorText(documentData);

        endDateField.visible = kindVal !== vacationKinds.martiallaw;

        const certificateLabelField = documentData.form.fields.find(f => f.name === 'sx:certificateLabel');
        const certificateSeriesField = documentData.form.fields.find(f => f.name === 'sx:certificateSeries');
        const certificateNumberField = documentData.form.fields.find(f => f.name === 'sx:certificateNumber');
        const birthCertificateDateField = documentData.form.fields.find(f => f.name === 'sx:birthCertificateDate');
        certificateLabelField.visible = kindVal === vacationKinds.childcare3;
        certificateSeriesField.visible = kindVal === vacationKinds.childcare3;
        certificateNumberField.visible = kindVal === vacationKinds.childcare3;
        birthCertificateDateField.visible = kindVal === vacationKinds.childcare3;

        const medichalCertificateLabelField = documentData.form.fields.find(f => f.name === 'sx:medichalCertificateLabel');
        const medichalCertificateDateField = documentData.form.fields.find(f => f.name === 'sx:medichalCertificateDate');
        const medicalCertificateNumberField = documentData.form.fields.find(f => f.name === 'sx:medicalCertificateNumber');
        medichalCertificateLabelField.visible = kindVal === vacationKinds.childcare6;
        medichalCertificateDateField.visible = kindVal === vacationKinds.childcare6;
        medicalCertificateNumberField.visible = kindVal === vacationKinds.childcare6;

        birthCertificateDateField.maxValue = moment(nowDate).format('YYYY-MM-DD');
        medichalCertificateDateField.maxValue = moment(nowDate).format('YYYY-MM-DD');

        const attchmentsField = documentData.form.fields.find(f => f.name === 'sx:attachments');
        if (attchmentsField) attchmentsField.visible = (kindVal === vacationKinds.childcare3 || kindVal === vacationKinds.childcare6) && formMode !== formModes.read;

        const canAdd = attchmentsField && (
            ((kindVal === vacationKinds.childcare3 || kindVal === vacationKinds.childcare6) && documentData.properties['sx:dfState'] === documentStatuses.preparing)
            || (documentData.properties['sx:dfState'] === documentStatuses.formationsigningOrder && hasSignBtn))
        setCanAddFiles(canAdd);

        updateLeftDaysText(documentData, limitsInfo);
    },

    checkInputPage(documentData, context) {
        let result = true;
        let errorElementName = '';
        let errorElementId = '';
        let nIndex = 0;

        const { updateDateValues } = context;

        const kindVal = documentData.properties['sx:dfDocKind'];

        const martiallaw = kindVal === vacationKinds.martiallaw;

        const nowDate = new Date();
        let minDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate());
        if (kindVal === vacationKinds.martiallaw || kindVal === vacationKinds.unpaid) {
            if (nowDate.getHours() >= 12) {
                minDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + 1);
            }
        }
        else {
            minDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + 5);
        }

        if (!martiallaw) {
            if (!(documentData.properties["sx:claimDateStart"] && documentData.properties["sx:claimDateEnd"])) {
                result = false;
                if (!documentData.properties["sx:claimDateStart"]) {
                    errorElementName = "sx:claimDateStart";
                }
                else {
                    errorElementName = "sx:claimDateEnd";
                }
            }
            else {
                const startDate = new Date(documentData.properties['sx:claimDateStart']);
                const endDate = new Date(documentData.properties['sx:claimDateEnd']);
                if (!(startDate >= minDate && endDate >= minDate && startDate <= endDate)) {
                    result = false;
                    errorElementName = "sx:claimDateEnd";
                }
            }
        }
        if (result && !martiallaw) {
            const sum = parseInt(documentData.properties['sx:claimeDaysSum']);
            if (sum < getVacationMinLength(kindVal)) {
                result = false;
                errorElementName = "sx:claimeDaysSum";
            }
        }
        if (result && martiallaw) {
            if (!documentData.properties["sx:claimDateStart"]) {
                result = false;
                errorElementName = "sx:claimDateStart";
            }
            else {
                const startDate = new Date(documentData.properties['sx:claimDateStart']);
                if (!(startDate >= minDate)) {
                    result = false;
                    errorElementName = "sx:claimDateEnd";
                }
            }
        }
        if (!result) {
            updateDateValues(minDate);
        }

        if (result && kindVal === vacationKinds.childcare3) {
            if (!documentData.properties["sx:certificateSeries"] || !documentData.properties["sx:certificateNumber"] || !documentData.properties["sx:birthCertificateDate"]) {
                result = false;
                if (!documentData.properties["sx:certificateSeries"]) {
                    errorElementName = "sx:certificateSeries";
                }
                else if (!documentData.properties["sx:certificateNumber"]) {
                    errorElementName = "sx:certificateNumber";
                }
                else {
                    errorElementName = "sx:birthCertificateDate";
                }
            }
            else {
                const nowDate = new Date();
                let maxDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + 1);
                const certificateDate = new Date(documentData.properties['sx:birthCertificateDate']);
                if (certificateDate > maxDate) {
                    result = false;
                    errorElementName = "sx:birthCertificateDate";
                }
            }
        }
        return {
            result,
            errorElementName,
            errorElementId,
            nIndex
        };
    }
};